'use strict';

var cart = require('../cart/cart');
var utils = require('../util/utils');
let isMobile = utils.isMobile();

var updateMiniCart = true;

module.exports = function () {
    cart();

    $('.minicart').on('count:update', function (event, count) {
        if (count && $.isNumeric(count.quantityTotal)) {
            $('.minicart .minicart-quantity').text(count.quantityTotal);
            $('.minicart .minicart-link').attr({
                'aria-label': count.minicartCountOfItems,
                title: count.minicartCountOfItems
            });
        }
    });

    var miniCart = document.querySelector('.minicart');

    /**
    * A/B TEST minicart-redesign. DO NOT MODIFY showMinicartOverlay or #minicart-backdrop click handler UNTIL minicart-redesign A/B TEST CONCLUDES.
    * HANDLE DISPLAY OF TRANSPARENT OVERLAY WHEN MINICART IS OPENED.
    */
    function showMinicartOverlay() {
        var minicartBackdrop = '<div id="minicart-backdrop" class="modal-backdrop fade show"></div>';
        $('body').addClass('modal-open').append(minicartBackdrop);
        $('#minicart-backdrop').show();
    }
    $('body').on('click', '#minicart-backdrop, .minicart-close', function () {
        $('#minicart-backdrop').remove();
        $('body').removeClass('modal-open');
    });

    // ORDERGROOVE'S BUILT-IN EVENT; DETECTS WHEN OFFERS ARE READY TO BE RENDERED IN UI
    if (miniCart) {
        miniCart.addEventListener('og-receive-offer', ev => {
            // IF THE TARGET MINICART ITEM IS A SUBSCRIPTION OPT-IN, TRIGGER A REFRESH OF THE DISPLAY PRICE
            if (ev.target.__subscribed) { // eslint-disable-line no-underscore-dangle
                ev.target.querySelector('og-optin-button').click();
            }
        });
    }
    // show & hide mini cart on button click
    $('.minicart').on('touchstart click', function (e, addToCartData) {
        var url = $('.minicart').data('action-url');
        var count = parseInt($('.minicart .minicart-quantity').text(), 10);
        // A/B TEST: IF ABTestMinicartA is true, user is a participant in the minicart-redesign A/B Test
        var ABTestMinicartA = typeof (addToCartData) !== 'undefined' ? addToCartData.minicartVariantA : $('.minicart .popover.minicartVariantA').length > 0;
        if (ABTestMinicartA) $('.minicart').css('position', 'static');
        if (count !== 0 && $('.minicart .popover.show').length === 0) {
            if (!updateMiniCart) {
                $('#minicart-item-added-msg:not(.d-sm-none)').addClass('d-sm-none');
                $('.minicart-header.d-sm-none').removeClass('d-sm-none').addClass('d-sm-block');

                $('.minicart .popover').addClass('show');
                if (ABTestMinicartA) showMinicartOverlay();
                return;
            }

            $('.minicart .popover').addClass('show');
            if (ABTestMinicartA) {
                $('.minicart .popover').animate({
                    width: isMobile ? '100vw' : '25rem',
                    speed: 'slow'
                });
                showMinicartOverlay();
            }
            $('.minicart .popover').spinner().start();
            $.get(url, function (data) {
                $('.minicart .popover').empty();
                $('.minicart .popover').append(data);
                updateMiniCart = false;

                // A/B TEST: minicart-redesign Variant A modifications.
                // DO NOT MODIFY FOLLOWING CODE BLOCK UNTIL minicart-redesign A/B Test concludes.
                if (typeof (addToCartData) !== 'undefined' && addToCartData.minicartVariantA) {
                    $('#minicart-item-added-msg.d-sm-none').removeClass('d-sm-none');
                    $('.minicart-header.d-sm-block').removeClass('d-sm-block').addClass('d-sm-none');
                    $('.minicart .popover:not(.minicartVariantA)').addClass('minicartVariantA');
                    $('.minicart .estimated-total').removeClass('d-sm-flex');
                    $('.minicart-close:first').focus();
                } else if (isMobile && addToCartData.pliUUID !== null) { // Mobile Minicart Experience: only show latest item added to cart
                    var showLatestItem = '.minicart .product-summary .card:not(.uuid-' + addToCartData.pliUUID + ')';
                    $(showLatestItem).hide();
                    $('.minicart-close').focus();
                }
                $.spinner().stop();
            });
        } else if (count !== 0 && $('.minicart .popover.show').length !== 0 && !e.target.length) {
            // make sure we're not removing a product
            if (e.target.classList.contains('icon-icon-cart-dims')) {
                $('.minicart .popover').removeClass('show');
            }
        }
    });

    // only allow shopping cart btn redirect for mobile users
    $('.minicart-total').on('touchstart click', function (e) {
        if (!isMobile) {
            e.preventDefault();
        } else if (isMobile) {
            e.stopImmediatePropagation();
            window.location = '/cart';
        }
    });

    // close mini cart on click off
    $('body').on('touchstart click', function (e) {
        // TO DO: consolidate the list of target elements used to trigger minicart close to avoid need for so many conditions
        if ($('.minicartVariantA.show').length === 1 && $(e.target).is('og-optin-button, og-optout-button')) return;
        if (($('.minicart-close').has(e.target).length > 0 || e.target.id === 'minicart-continue-shopping')
        || $('.minicart').has(e.target).length <= 0) {
            $('.minicart .popover').removeClass('show');
        }
    });
    $('.minicart').on('mouseleave focusout', function (event) {
        if ((event.type === 'focusout' && $('.minicart').has(event.target).length > 0)
            || (event.type === 'mouseleave' && $(event.target).is('.minicart .quantity'))
            || $('body').hasClass('modal-open')) {
            event.stopPropagation();
            return;
        }
    });
    $('body').on('change', '.minicart .quantity', function () {
        if ($(this).parents('.bonus-product-line-item').length && $('.cart-page').length) {
            location.reload();
        }
    });
    $('body').on('product:afterAddToCart', function (e, data) { // eslint-disable-line no-unused-vars
        updateMiniCart = true;
    });
    $('body').on('cart:update', function () {
        updateMiniCart = true;
    });
};
